// extracted by mini-css-extract-plugin
export default {"particles":"Particles_particles__yzDC-"};